var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H30V30H0V0Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88781 25.0703L10.1835 23.6809C10.6265 24.4662 11.0294 25.1306 11.9958 25.1306C12.9222 25.1306 13.5064 24.7683 13.5064 23.3588V13.7731H16.3255V23.3986C16.3255 26.3186 14.6139 27.6477 12.1166 27.6477C9.86137 27.6477 8.55227 26.4797 7.8877 25.0701L7.88781 25.0703ZM17.8568 24.7682L20.1523 23.4392C20.7566 24.426 21.542 25.1509 22.9314 25.1509C24.0996 25.1509 24.8445 24.5669 24.8445 23.7613C24.8445 22.7947 24.0793 22.4523 22.7904 21.8887L22.0858 21.5863C20.0518 20.7206 18.7026 19.6331 18.7026 17.3374C18.7026 15.2229 20.3136 13.6118 22.8309 13.6118C24.6231 13.6118 25.9119 14.2362 26.8382 15.8673L24.643 17.2771C24.1596 16.4112 23.6363 16.0689 22.8307 16.0689C22.005 16.0689 21.4814 16.5925 21.4814 17.2771C21.4814 18.1228 22.005 18.4654 23.2132 18.989L23.918 19.291C26.3145 20.3181 27.6637 21.3652 27.6637 23.7211C27.6637 26.2587 25.6701 27.6481 22.9918 27.6481C20.3739 27.6481 18.6823 26.3996 17.8567 24.7683",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.cbfc122ac7423199d7d200440b00cad6.svg";
export { ForwardRef as ReactComponent };